import { Background } from "./Background";

export default Background;
